import { discardPostSettings } from '../../../common/store/post-settings/discard-post-settings';

export const discardPostSettingsModalResolver = () => (dispatch) => {
  return dispatch(discardPostSettings());
};
